module.exports = __webpack_public_path__ + "static/media/Octo_Waffle_logo.be1394d2.svg";